// Backend errors come back as { message } or zod { errors: [{ path, message }] }
export const readErrorMessage = async (response) => {
  try {
    const body = await response.json();
    if (Array.isArray(body?.errors) && body.errors.length) {
      return body.errors.map((e) => `${e.path}: ${e.message}`).join("; ");
    }
    return body?.message || body?.Message || JSON.stringify(body);
  } catch {
    return `Request failed (${response.status})`;
  }
};
